export default "__VITE_ASSET__DbSlHgI$__"